/**
 * Public checkout shipping rates (Shiprocket serviceability).
 */
export async function fetchCheckoutShippingRates({ pincode, parcel }) {
  const deliveryPostcode = String(pincode || "").trim();
  if (!/^\d{6}$/.test(deliveryPostcode)) {
    return { ok: false, message: "Enter a valid 6-digit pincode." };
  }

  try {
    const res = await fetch("/api/shiprocket/rates", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deliveryPostcode, parcel }),
    });
    const text = await res.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      const snippet = String(text || "").replace(/\s+/g, " ").trim().slice(0, 80);
      if (!res.ok) {
        return {
          ok: false,
          message: `Shipping rates unavailable (HTTP ${res.status}).${snippet ? ` ${snippet}` : ""}`,
        };
      }
      return {
        ok: false,
        message:
          "Shipping service returned an unexpected response. If this persists, contact support.",
      };
    }

    if (!res.ok || data?.ok === false) {
      if (res.status === 404) {
        return {
          ok: false,
          message:
            data?.message ||
            "Shipping rates API not found. Redeploy the site on Netlify (latest main) so /api/shiprocket/rates is available.",
        };
      }
      return {
        ok: false,
        message: data?.message || `Could not load shipping rates (HTTP ${res.status}).`,
      };
    }
    if (!data?.ok) {
      return {
        ok: false,
        message: "Shipping rates are not configured on the server yet.",
      };
    }
    return {
      ok: true,
      senderPincode: data.senderPincode,
      receiverPincode: data.receiverPincode,
      options: Array.isArray(data.summary?.options) ? data.summary.options : [],
    };
  } catch (err) {
    return { ok: false, message: err?.message || "Network error while loading shipping rates." };
  }
}
